// Hem of Grace Events - Website Data

export const siteConfig = {
  businessName: "Hem of Grace Events",
  tagline: "Graceful, unforgettable events rooted in love and intention.",
  location: "Based in Florida",
  email: "Hemofgraceevents@gmail.com",
  social: {
    instagram: "https://www.instagram.com/hem_of_grace_events",
    tiktok: "https://www.tiktok.com/@hemofgraceevents",
    facebook: "https://www.facebook.com/hemofgraceevents"
  }
};

export const heroContent = {
  title: "Florida Wedding & Event Planner",
  subtitle: "Graceful, unforgettable events rooted in love and intention.",
  ctaText: "Request a Consultation",
  description: "Luxury event design and planning services creating beautiful celebrations with personalized attention and seamless coordination throughout Florida."
};

export const aboutContent = {
  title: "Our Story",
  subtitle: "Where Faith Meets Floral Beauty",
  paragraphs: [
    "At Hem of Grace Events, we believe every celebration is an opportunity to create lasting memories filled with grace, beauty, and love. Based in Florida, we specialize in designing weddings and special events that reflect your unique story.",
    "Our name draws inspiration from the biblical story of the woman who reached out to touch the hem of Jesus' garment, believing in transformation and hope. In that same spirit, we approach each event with intention, creativity, and a commitment to making your vision a stunning reality.",
    "From intimate gatherings to grand celebrations, our team brings meticulous attention to detail, creative vision, and a heart for service. Let us help you create graceful events in Florida that will be treasured for a lifetime."
  ],
  imageUrl: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/vpznwv80_image16.jpeg"
};

export const services = [
  {
    id: 1,
    title: "Wedding Planning & Coordination",
    description: "Your love story deserves a celebration as unique as your journey together.",
    features: [
      "Full wedding planning & design",
      "Day-of coordination",
      "Ceremony & reception styling",
      "Vendor management"
    ],
    imageUrl: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/tubs29we_image8.jpeg"
  },
  {
    id: 2,
    title: "Quinceañera & Sweet 16",
    description: "Celebrate this milestone with an unforgettable, beautifully designed party.",
    features: [
      "Theme development & styling",
      "Venue decoration & setup",
      "Custom backdrops & florals",
      "Full event coordination"
    ],
    imageUrl: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/kk7klvrq_image17.jpeg"
  },
  {
    id: 3,
    title: "Birthday Parties & Celebrations",
    description: "Make every birthday a colorful, memorable celebration filled with joy.",
    features: [
      "Custom theme design",
      "Balloon & floral décor",
      "Table settings & styling",
      "Dessert table setup"
    ],
    imageUrl: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/4oy61j6g_image18.jpeg"
  },
  {
    id: 4,
    title: "Baby Showers & Gender Reveals",
    description: "Welcome new life with a beautifully designed celebration.",
    features: [
      "Theme creation & styling",
      "Custom centerpieces",
      "Games & activities setup",
      "Gift table arrangements"
    ],
    imageUrl: "https://customer-assets.emergentagent.com/job_54544642-256c-49a8-b79e-1e945d33b744/artifacts/lbcp86y8_image2.jpeg"
  },
  {
    id: 5,
    title: "Faith-Based & Church Events",
    description: "Honor your faith with beautifully designed church celebrations.",
    features: [
      "Baptism & dedication ceremonies",
      "Church anniversary events",
      "Ministry event coordination",
      "Spiritual retreat design"
    ],
    imageUrl: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/e4wfhqpl_image5.jpeg"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/vpznwv80_image16.jpeg",
    alt: "Hem of Grace Events luxury floral centerpiece with pink and white roses"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/wdvnekc4_image15.jpeg",
    alt: "Hem of Grace Events space themed birthday party Florida event design"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/tubs29we_image8.jpeg",
    alt: "Hem of Grace Events Florida wedding planner outdoor setup with lavender draping"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/3rm2m55c_image9.jpeg",
    alt: "Hem of Grace Events luxury event designer floral arrangement purple lavender roses"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/kk7klvrq_image17.jpeg",
    alt: "Hem of Grace Events quinceañera butterfly throne Florida celebration"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/4oy61j6g_image18.jpeg",
    alt: "Hem of Grace Events Coco themed birthday party colorful balloon arch Florida"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/tg998z4l_image19.jpeg",
    alt: "Hem of Grace Events centerpiece with guitar marigolds Florida event planner"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/m36z21mt_image20.jpeg",
    alt: "Hem of Grace Events memorial display with balloon arch graceful events Florida"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/wni45bcf_image21.jpeg",
    alt: "Hem of Grace Events birthday dessert table balloon garland Florida party planner"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/e4wfhqpl_image5.jpeg",
    alt: "Hem of Grace Events faith-based centerpiece cross blue hydrangeas Florida"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/8lmdp5il_image6.jpeg",
    alt: "Hem of Grace Events church event elegant long table setup Florida wedding coordination"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/ylzlg2ge_image7.jpeg",
    alt: "Hem of Grace Events Florida celebration candles blue florals luxury event"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_54544642-256c-49a8-b79e-1e945d33b744/artifacts/k7bq31my_image1.jpeg",
    alt: "Hem of Grace Events wedding floral arrangements white columns Florida planner"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_54544642-256c-49a8-b79e-1e945d33b744/artifacts/lbcp86y8_image2.jpeg",
    alt: "Hem of Grace Events baby shower setup elegant draping graceful events Florida"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_54544642-256c-49a8-b79e-1e945d33b744/artifacts/t9bviw5p_image3.jpeg",
    alt: "Hem of Grace Events royal throne blue draping special event Florida"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_54544642-256c-49a8-b79e-1e945d33b744/artifacts/i0gqvc24_image4.jpeg",
    alt: "Hem of Grace Events grand church celebration golden gates Florida event design"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/nuzp2eae_image10.jpeg",
    alt: "Hem of Grace Events rustic barn wedding setup Florida wedding planner"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/ajynn3h7_image11.jpeg",
    alt: "Hem of Grace Events garden pergola purple florals luxury event designer"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/j76vkpxs_image12.jpeg",
    alt: "Hem of Grace Events elegant table centerpiece Florida event planning"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/0x9nq97m_image13.jpeg",
    alt: "Hem of Grace Events golden gazebo structure wedding coordination Florida"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_graceful-events/artifacts/gg4tc3f9_image14.jpeg",
    alt: "Hem of Grace Events birthday party centerpiece Florida event planner"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria & Carlos",
    event: "Wedding",
    quote: "Hem of Grace Events made our dream wedding come true. Every detail was perfect, from the floral arrangements to the seamless coordination. We couldn't have asked for a more beautiful day.",
    location: "Miami, FL"
  },
  {
    id: 2,
    name: "The Rodriguez Family",
    event: "Quinceañera",
    quote: "Our daughter's quinceañera was absolutely magical. The butterfly theme with the throne setup exceeded all our expectations. Thank you for making her day so special!",
    location: "Orlando, FL"
  },
  {
    id: 3,
    name: "Pastor David & Lisa",
    event: "Church Anniversary",
    quote: "The attention to detail and the heart behind their work truly set them apart. Our church celebration was beautiful beyond words. Highly recommend!",
    location: "Tampa, FL"
  }
];

export const eventTypes = [
  "Wedding",
  "Quinceañera / Sweet 16",
  "Baby Shower",
  "Birthday Party",
  "Church/Faith Event",
  "Corporate Event",
  "Other"
];
